import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Dispatch } from 'redux';
import { EntityMenu } from '../../../shared/Domain/EntityMenu';
import { AdapterGenerico } from '../../../shared/Infraestructure/AdapterGenerico';
import { RootState } from '../../../shared/Infraestructure/AdapterStore';
import { LanguageTranslate } from '../../../shared/Infraestructure/LanguageTranslate';
import { addLoading, changeBreadcrumbList, changePageTitle, changeSaludo, hideIconMenu, removeLoading } from '../../../shared/Infraestructure/SliceGenerico';
import { AdapterStorage } from '../../../shared/Infraestructure/AdapterStorage';
import { useState } from 'react';
import { EntityModalPermiss, initEntityModalPermiss } from '../Domain/Utils';
import { AdapterNotification, TypeModeNotification } from '../../../shared/Infraestructure/AdapterNotification';

export const Controller = () => {
    let { auth: { menu, user } } = useSelector((state: RootState) => state);
    const [modalPermiss, setModalPermiss] = useState<EntityModalPermiss>(initEntityModalPermiss)
    const languageTranslate = LanguageTranslate();
    const dispatch: Dispatch = useDispatch();
    const navigate = useNavigate();
    const listUserNotRequiredForceChangePassword = ['42818675', '71010508', '73457827', '000957065', '72370779', '14620977', '000100148', '72720804'];

    menu = menu.filter(row => row.esOpcion && !row.padre);

    const init = async () => {
        dispatch(hideIconMenu());
        dispatch(changeSaludo(true));
        dispatch(changePageTitle(''));
        dispatch(changeBreadcrumbList([]));
        if (user.ChangePasswordObligate && !listUserNotRequiredForceChangePassword.includes(user.Identificacion)) navigate(`/${process.env.REACT_APP_ROUTE_PATH_CHANGEPASSWORD}`, { replace: true });
        else onShowRequiredNotificationPermiss();
    };

    const onClickAyuda = async () => {
        let confirmacion: boolean = await AdapterGenerico.createMessage(languageTranslate.moduloMain.textoTituloPreguntaAyuda, languageTranslate.moduloMain.textoDescripcionPreguntaAyuda, 'question', true);
        if (!confirmacion) return;
        window.open('https://www.cobraperu.com.pe/helpcenter/sistema-sgso/', '_blank');
    };

    const onClickReport = async () => {
        let confirmacion: boolean = await AdapterGenerico.createMessage(languageTranslate.moduloMain.textoTituloPreguntaReporte, languageTranslate.moduloMain.textoDescripcionPreguntaReporte, 'question', true);
        if (!confirmacion) return;
        window.open('https://www.cobraperu.com.pe/glpi/', '_blank')
    };

    const onClickMenu = (element: EntityMenu) => {
        navigate(`/${element.ruta}`, { replace: true });
    };

    const onShowRequiredNotificationPermiss = async () => {
        /*const { showMessageRequiredNotification } = AdapterStorage.get('showMessageRequiredNotification');
        if (showMessageRequiredNotification) return;

        const hasNotificationActive = await new AdapterNotification().hasNotificationPermission();
        setModalPermiss(() => ({
            show: true,
            step: hasNotificationActive ? 'type-permiss' : 'required',
            options: [1]
        }));*/
    };

    const onSubmit = async () => {
        try {
            dispatch(addLoading({}))
            if (!modalPermiss.options.length) throw new Error(languageTranslate.moduloNotificacion.validate.metodoNotificacion);
            const dictionaryOptions: Record<number, TypeModeNotification> = {
                1: 'INDIVIDUAL',
                2: 'GROUP',
            }
            const modeNotification: TypeModeNotification = modalPermiss.options.length > 1 ? 'ALL' : dictionaryOptions[modalPermiss.options[0]];

            await new AdapterNotification().subscribe(user, modeNotification);
            AdapterGenerico.createMessage(languageTranslate.textoExitoso, languageTranslate.moduloNotificacion.formSuccess, 'success')
            closeModal();
        } catch (error) {
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'warning');
        } finally {
            dispatch(removeLoading())
        }
    }

    const onChangeOptionsPermiss = (newValue: number) => {
        const newOptions = modalPermiss.options;
        const indexOption = newOptions.findIndex(row => row === newValue);
        indexOption === -1 ? newOptions.push(newValue) : newOptions.splice(indexOption, 1);
        setModalPermiss((prev) => ({ ...prev, options: newOptions }))
    }

    const closeModal = () => {
        setModalPermiss(() => ({
            show: false,
            step: 'required',
            options: []
        }));
        AdapterStorage.set('showMessageRequiredNotification', 'true');
    }

    return {
        init,
        menu,

        modalPermiss,
        onChangeOptionsPermiss,
        closeModal,
        onSubmit,

        onClickAyuda,
        onClickReport,
        onClickMenu,
    };
}